import { b64Uri, getElement, getJson, resetForm, setSelect2Ajax } from "../../../../../helpers";

export class MetricModal extends HTMLDivElement {
    connectedCallback() {
        this.load();
    }

    load() {
        // console.log(this);
        const Form = getElement("[data-form=form]", this);

        Form.elements.save.addEventListener("click", () => {
            if (Form.reportValidity()) {
                Form.submit();
            }
        });
    }

    static create(modal, title, url) {
        const Form = getElement("[data-form=form]", getElement(modal));
        resetForm(Form, title, url);
    }

    static edit(modal, title, url, data) {
        data = getJson(b64Uri(data, "decode"));
        const Form = getElement("[data-form=form]", getElement(modal));
        resetForm(Form, title, url);
        Form.elements.name.value = data.name;
        Form.elements.unit.value = data.unit;
        Form.elements.description.value = data.description;
        setSelect2Ajax(Form.elements.type_metrics_id,data.typemetric.id,data.typemetric.name,data.typemetric);
    }
}

window.customElements.define("metric-modal", MetricModal, {
    extends: "div",
});
